import { useState, type FormEvent } from "react";
import { Navigate, useNavigate } from "react-router";
import { ApiClientError } from "../api/client.js";
import { useAuth } from "../auth/AuthProvider.js";

export function LoginPage() {
  const { state, login, notice } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [pending, setPending] = useState(false);
  const [error, setError] = useState<string>();

  if (state.status === "loading") {
    return (
      <main className="foundation-status-page" aria-live="polite">
        <span className="foundation-spinner" aria-hidden="true" />
        <p>正在恢复安全会话…</p>
      </main>
    );
  }

  if (state.status === "authenticated") {
    return (
      <Navigate
        to={state.user.mustChangePassword ? "/change-password" : "/projects"}
        replace
      />
    );
  }

  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (!username.trim() || !password) {
      setError("请输入用户名和密码。");
      return;
    }
    setPending(true);
    setError(undefined);
    try {
      const user = await login(username.trim(), password);
      navigate(user.mustChangePassword ? "/change-password" : "/projects", {
        replace: true
      });
    } catch (cause) {
      setError(
        cause instanceof ApiClientError && cause.status === 401
          ? "用户名或密码不正确。"
          : "暂时无法登录，请检查网络后重试。"
      );
    } finally {
      setPending(false);
    }
  }

  return (
    <main className="foundation-auth-page">
      <section className="foundation-auth-card">
        <div className="foundation-auth-brand" aria-hidden="true">
          S
        </div>
        <p className="foundation-eyebrow">PRIVATE CREATIVE WORKSPACE</p>
        <h1>登录 Seedance Studio</h1>
        <p className="foundation-muted">
          进入仅属于你的项目空间。会话凭据由安全 Cookie 管理。
        </p>
        {notice ? (
          <p className="foundation-alert foundation-alert--info" role="status">
            {notice}
          </p>
        ) : null}
        <form className="foundation-form" onSubmit={submit}>
          <label>
            <span>用户名</span>
            <input
              autoComplete="username"
              value={username}
              onChange={(event) => setUsername(event.target.value)}
              disabled={pending}
            />
          </label>
          <label>
            <span>密码</span>
            <input
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              disabled={pending}
            />
          </label>
          {error ? (
            <p className="foundation-alert foundation-alert--error" role="alert">
              {error}
            </p>
          ) : null}
          <button
            className="foundation-button foundation-button--primary"
            type="submit"
            disabled={pending}
          >
            {pending ? "正在登录…" : "登录"}
          </button>
        </form>
      </section>
    </main>
  );
}
